import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { InvoiceData } from "@/types/invoice";

interface InvoiceState {
  data: InvoiceData | null;
  loading: boolean;
  error: string | null;
}

const initialState: InvoiceState = {
  data: null,
  loading: false,
  error: null,
};

const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    setInvoiceLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setInvoiceData: (state, action: PayloadAction<InvoiceData>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    setInvoiceError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearInvoice: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setInvoiceLoading,
  setInvoiceData,
  setInvoiceError,
  clearInvoice,
} = invoiceSlice.actions;

export default invoiceSlice.reducer;
